import { on } from "@ngrx/store";
import { DiscountTypes } from "graphql.generated";
import { cloneDeep } from "lodash";

import { JobMutateChargeActions } from "src/app/job/mutate-charges/mutate-charges.actions";

import { AddDiscountsModalActions } from "../add-discounts-modal/add-discounts-modal.actions";
import { WorkOrdersActions } from "../job-workorders/job-workorders.actions";
import { jobMutateChargesInitialState } from "../mutate-charges/mutate-charges.state";
import { jobMutateDiscountsInitialState } from "../mutate-discount/mutate-discount.state";

import { JobMutateObjectActions } from "./mutate-object.actions";
import { MutateObjectState, jobMutateObjectInitialState, jobMutatorsInitialState } from "./mutate-object.state";

export const jobMutateObjectReducers = [
  on(
    JobMutateObjectActions.previousButtonClicked,
    JobMutateObjectActions.nextButtonClicked,
    JobMutateObjectActions.pageIndicatorClicked,
    (state: MutateObjectState, action): MutateObjectState => {

      let footerButtons = state.mutateObjectDialog.footerButtons;

      const isReview = state.mutateObjectDialog.activeStep === 'review';

      if (action.type === JobMutateObjectActions.pageIndicatorClicked.type && isReview) {
        footerButtons = 'review';
      }

      return {
        ...state,
        mutateObjectDialog: {
          ...state.mutateObjectDialog,
          activeStep: action.step,
          footerButtons,
        }
      };
    },
  ),
  on(JobMutateObjectActions.reviewButtonClicked, (state: MutateObjectState): MutateObjectState => {
    return {
      ...state,
      mutateObjectDialog: {
        ...state.mutateObjectDialog,
        activeStep: 'review',
        footerButtons: 'mutate',
      }
    };
  }),
  on(
    JobMutateObjectActions.exitMutateObjectDialogButtonClicked,
    JobMutateObjectActions.escapeKeyPressed,
    (state: MutateObjectState): MutateObjectState => {

      const { activeMutator } = state.mutateObjectDialog;

      const mutators = {
        ...cloneDeep(state.mutateObjectDialog.mutators),
        // Reset active mutator
        [ activeMutator ]: jobMutatorsInitialState[activeMutator],
      };

      return {
        ...state,
        mutateObjectDialog: {
          ...jobMutateObjectInitialState.mutateObjectDialog,
          mutators,
        },
      };
    },
  ),
  on(JobMutateObjectActions.reviewListboxItemClicked, (state: MutateObjectState, { step }): MutateObjectState => {
    return {
      ...state,
      mutateObjectDialog: {
        ...state.mutateObjectDialog,
        activeStep: step,
        footerButtons: 'review',
      }
    };
  }),
  on(JobMutateObjectActions.enterKeyPressed, (state: MutateObjectState, { goToStep, mutate }): MutateObjectState => {

    if (!goToStep && !mutate) { return state; }

    let footerButtons = state.mutateObjectDialog.footerButtons;

    if (goToStep === 'review') {
      footerButtons = 'mutate';
    }

    if (goToStep) {
      return {
        ...state,
        mutateObjectDialog: {
          ...state.mutateObjectDialog,
          activeStep: goToStep,
          footerButtons,
        }
      };
    }

    // To do: mutate
    return {
      ...state,
    };
  }),
  on(WorkOrdersActions.chargesAdded, (state: MutateObjectState): MutateObjectState => {
    return {
      ...state,
      mutateObjectDialog: {
        ...jobMutateObjectInitialState.mutateObjectDialog,
      },
    };
  }),
  on(WorkOrdersActions.addCustomChargeButtonClicked, (state: MutateObjectState, { eventId }): MutateObjectState => {
    return {
      ...state,
      mutateObjectDialog: {
        ...jobMutateObjectInitialState.mutateObjectDialog,
        mutateType: 'create',
        activeMutator: 'charge',
        activeStep: 'Product',
        mutators: {
          ...state.mutateObjectDialog.mutators,
          charge: {
            ...jobMutateChargesInitialState,
            eventIds: [ eventId ],
          },
        },
      },
    };
  }),
  on(WorkOrdersActions.discountAdded, (state: MutateObjectState): MutateObjectState => {
    return {
      ...state,
      mutateObjectDialog: {
        ...jobMutateObjectInitialState.mutateObjectDialog,
      },
    };
  }),
  on(AddDiscountsModalActions.mutateDiscountDialogOpened, (state: MutateObjectState, { jobCode, eventIds }): MutateObjectState => {

    const discountName = `Discount for ${jobCode}`;

    const last6 = (Math.floor(new Date().getTime() / 1000)).toString().slice(-6); // Use last 6 digit to prevent duplicate errors

    const code = `${jobCode}-${last6}`;

    return {
      ...state,
      mutateObjectDialog: {
        ...jobMutateObjectInitialState.mutateObjectDialog,
        mutateType: 'create',
        activeMutator: 'discount',
        activeStep: 'Name',
        mutators: {
          ...state.mutateObjectDialog.mutators,
          discount: {
            ...jobMutateDiscountsInitialState,
            eventIds,
            discountName,
            code,
            discountType: DiscountTypes.Amount,
          },
        }
      }
    };
  }),
  on(JobMutateChargeActions.chargeLoaded, (state: MutateObjectState, { charge, eventId }): MutateObjectState => {

        const {
            modified: _modified,
            new: _isNew,
            removed: _removed,
            ...mutateChargeState
        } = charge;

        return {
            ...state,
            mutateObjectDialog: {
                ...jobMutateObjectInitialState.mutateObjectDialog,
                mutateType: 'update',
                activeMutator: 'charge',
                activeStep: 'Description',
                mutators: {
                    ...state.mutateObjectDialog.mutators,
                    charge: {
                        ...mutateChargeState as typeof jobMutateChargesInitialState,
                        eventIds: [ eventId ],
                    }
                }
            },
        }

  }),
  on(WorkOrdersActions.chargeDescriptionChanged, (): MutateObjectState => {
    return {
      mutateObjectDialog: {
        ...jobMutateObjectInitialState.mutateObjectDialog,
      }
    }
  }),
];
